import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ToastService} from '../core/toaster/toast.service';
import {StoreService} from '../core/common/store/store.service';
import {Configuration} from '../core/common/configuration';
import {RoutingService} from '../core/common/routing.service';
import {SettingService} from '../core/common/settings.service';


@Injectable()
export class ErrorHandlerService {

  constructor(private settings: SettingService,
              private toastService: ToastService,
              private storeService: StoreService,
              private routing: RoutingService,
              private config: Configuration) {
  }

  dispatch(error: HttpErrorResponse, errorMessage: string): string {
    let errMess: string;
    if (error.error instanceof ErrorEvent) {
      errMess = 'A client-side or network error occurred: ' + error.error.message;
    } else {
      errMess = `Backend returned code ${error.status}`;
    }
    if (errorMessage) {
      this.actions(error, errorMessage);
      return errorMessage + ' ' + errMess;
    }
    return errMess;
  }

  private actions(error: HttpErrorResponse, errorMessage: string): void {
    this.setErrorCache(error);
    if (error.status / 100 === 5) {
      this.routing.navigateTo('/500');
    } else {
      switch (error.status) {
        case 401:
          this.storeService.deleteAll();
          this.toastService.stopToastError = false;
          this.routing.navigateTo('/login');
          break;
        case 409:
          break;
        default:
          this.showToast(errorMessage);
      }
    }
  }

  private setErrorCache(error: HttpErrorResponse): void {
    this.settings.getError().code = error.status;
    if (this.config.HEADER_FIELDS.authCodeField && this.config.HEADER_FIELDS.errorMessage) {
      this.settings.getError().authCode = error.headers.get(this.config.HEADER_FIELDS.authCodeField);
      this.settings.getError().errorMessage = error.headers.get(this.config.HEADER_FIELDS.errorMessage);
    }
  }

  private showToast(errorMessage: string): void {
    this.toastService.showToasterError(errorMessage);
  }

}
